/**
 * Chính sách thử lại mặc định của react-query (gắn ở `router.tsx`).
 *
 * 🔴 KHÔNG thử lại khi server ĐÃ trả lời (5xx, 503 quá tải, 4xx, lỗi auth): server
 * nói "tôi đang quá tải" mà mỗi query trên mỗi máy lại gõ thêm lần nữa là nhân đôi tải
 * đúng lúc tệ nhất — nhất là khi `/v1/bootstrap` hỏng thì ~10 query cùng hỏng một
 * lúc. Query lỗi sẽ tự lấy lại ở lần mount/điều hướng kế tiếp hoặc theo nhịp
 * `refetchInterval` của nó.
 *
 * Chỉ thử lại lỗi MẠNG thật (fetch ném `TypeError`: rớt sóng, đổi mạng trên điện
 * thoại) — thường tự khỏi sau vài giây. Độ trễ có JITTER để hàng loạt máy mất mạng
 * cùng lúc không quay lại cùng một khoảnh khắc.
 */
const MAX_RETRIES = 1;
const RETRY_BASE_DELAY_MS = 3000;

export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (failureCount >= MAX_RETRIES) return false;
  return error instanceof TypeError;
}

/** 3s × 2^lần, nhân ngẫu nhiên 0.5–1.5 (lần đầu rơi vào ~1.5–4.5s). */
export function queryRetryDelay(attemptIndex: number): number {
  return RETRY_BASE_DELAY_MS * 2 ** attemptIndex * (0.5 + Math.random());
}
